import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WORK_SHIFTS_PATHS } from './work-shifts';

import { WorkShiftsComponent } from './work-shifts/work-shifts.component';
import { AuthGuard } from '../../pages/auth/auth.guard.service';

const routes: Routes = [
  {
    path: WORK_SHIFTS_PATHS.work_shifts,
    component: WorkShiftsComponent,
    canActivate: [AuthGuard],
    data: { animation: 'WorkShiftsPage', permission: 'schedule.get' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorkShiftRoutingModule {}
